import { samplesRoute } from '@/app/account/samples/samples-page.tsx';
import { projectsRoute } from '@/app/account/projects/projects-page.tsx';
import { projectViewRoute } from '@/app/account/projects/project-view-page.tsx';
import { profileRoute } from '@/app/account/profile/profile-page.tsx';

export const accountRoutes = [samplesRoute, projectsRoute, projectViewRoute, profileRoute];